/* The reveal gate for the matched parts grid.

   THE FAULT. Load the results and scroll quickly and you catch the cards mid
   build: the extension paints them before its own styling and before the
   photographs arrive, so for a second or so the grid shows the stock Shopify
   card look and then snaps into ours. A stylesheet cannot fix that, because
   the thing being seen is a correct render of an earlier state.

   THE RULE. A card does not appear until its own photograph has decoded. Until
   then it is a skeleton of exactly the same height, because the frame's
   aspect-ratio is set in CSS rather than by the image, so nothing reflows when
   the image lands and the grid never jumps.

   IT CANNOT STRAND A CARD. Three separate releases: the load event, a check for
   images that were already complete before we attached, and a hard four second
   timeout per card that fires whatever happened. If this file fails to parse,
   the CSS still hides the cards, which is why the timeout is the important one
   and why it is armed before anything else can throw.

   decode() IS NOT USED. It rejects on a broken image, and a broken image still
   needs its card shown. load and error both mean "stop waiting".

   LAZY IMAGES BELOW THE FOLD NEVER FIRE load UNTIL THEY SCROLL IN, WHICH IS
   CORRECT. Those cards sit as skeletons until the customer reaches them, and
   the four second timeout releases them anyway if the browser decides not to
   fetch at all. */
(function () {
  var READY = 'fx-card-ready';
  var GRID = '.vin-fx-diagram-grid';
  var CARD = '.diagram-card';
  var HOLD = 4000;
  var queued = null;

  function release(card) {
    if (!card || card.classList.contains(READY)) return;
    card.classList.add(READY);
  }

  function watch(card) {
    if (card.getAttribute('data-fx-gate') === '1') return;
    card.setAttribute('data-fx-gate', '1');

    /* Armed first, so nothing below can leave this card hidden forever. */
    window.setTimeout(function () { release(card); }, HOLD);

    var img = card.querySelector('.diagram-thumb img');
    if (!img) { release(card); return; }

    if (img.complete && img.naturalWidth > 0) { release(card); return; }

    img.addEventListener('load', function () { release(card); });
    img.addEventListener('error', function () { release(card); });
  }

  function pass() {
    queued = null;
    var grids = document.querySelectorAll(GRID);
    for (var g = 0; g < grids.length; g++) {
      var cards = grids[g].querySelectorAll(CARD);
      for (var c = 0; c < cards.length; c++) watch(cards[c]);
    }
  }

  function schedule() {
    if (queued) return;
    queued = window.setTimeout(pass, 60);
  }

  function boot() {
    pass();
    if (!window.MutationObserver) return;
    new window.MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
